import { type ComponentProps, type FC, createElement } from 'react';

import { Box } from '@eneco/sparky';
import { getClassNames } from '@eneco/sparky/util/css';

import { backgroundClass, relativeClass } from './Section.css';

export const Relative: FC<ComponentProps<'section'>> = ({ className, ...props }) =>
  createElement('section', { ...props, className: getClassNames(relativeClass, className) });

export const Background: FC<ComponentProps<typeof Box>> = ({ className, ...props }) => (
  <Box {...props} className={getClassNames(backgroundClass, className)} />
);
